var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionHideOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m2.293 3.707 18 18 1.414-1.414-2.642-2.642C22.355 15.29 24 12 24 12s-4-8-12-8c-2.025 0-3.794.513-5.307 1.279L3.707 2.293 2.293 3.707Zm5.904 3.076 1.771 1.77a4 4 0 0 1 5.478 5.478l2.183 2.184a13.424 13.424 0 0 0 1.957-1.63c.95-.949 1.651-1.907 2.093-2.585a16.26 16.26 0 0 0-2.093-2.586C17.804 7.632 15.283 6 12 6c-1.407 0-2.674.3-3.803.783Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.607 17.866 1.697 1.656A11.532 11.532 0 0 1 12 20c-8 0-12-8-12-8s1.15-2.298 3.448-4.431l1.415 1.415A16.215 16.215 0 0 0 2.32 12a16.257 16.257 0 0 0 2.093 2.586C6.196 16.368 8.718 18 12 18a9.62 9.62 0 0 0 1.607-.134Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionHideOutlined);
export default __webpack_public_path__ + "static/media/ic_action_hide_outlined.dbfd6033d834c919de165391c10efcc0.svg";
export { ForwardRef as ReactComponent };